var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-dashboard-modal"},[_c('p',[_vm._v(_vm._s(_vm.$t('deleteDashboardPopup.subTitle', { dashboardName: _vm.dashboardName })))]),(_vm.errorMessage)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }